import http from "../plugins/axios"

export const createUserAnswer = async (payload) => {
  try {
    const response = await http.post(`/user-answers`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}